import type {
  DecimalValue,
  NumberValue,
  Value,
} from '@snap-types/models/auto-configurator/state';
import { Decimal } from '@snap-types/types/decimal';

export function setNumberValue(
  valueObject: NumberValue,
  newValue: number,
  rawValue?: string,
) {
  if (!rawValue) {
    rawValue = String(newValue);
  }

  valueObject.value = newValue;
  valueObject.rawValue = rawValue;
}

/**
 * @allowUnusedExport
 */
export function setDecimalValue(
  valueObject: DecimalValue,
  newValue: Decimal,
  rawValue?: string,
) {
  if (!rawValue) {
    rawValue = newValue.toString();
  }

  valueObject.value = newValue;
  valueObject.rawValue = rawValue;
}

export function resetValue(valueObject: Value) {
  valueObject.rawValue = '';
  valueObject.isDirty = false;
  valueObject.isTouched = false;
  valueObject.isValid = true;
  valueObject.hasParseError = false;
  valueObject.errors = [];

  if (valueObject.type === 'boolean') {
    valueObject.value = false;
  } else {
    valueObject.value = null;
  }
}
